export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 61 62" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="web端" transform="translate(-1248.000000, -5335.000000)">
                    <g id="编组-18备份" transform="translate(1250.000000, 5336.708031)">
                        <path
                            d="M30.2937031,58.8563375 L23.9591164,58.8563375 L6.05874062,58.8563375 C2.71259057,58.8563375 0,56.1437469 0,52.7975968 L0,6.05874062 C0,2.71259057 2.71259057,0 6.05874062,0 L30.2937031,0 C33.6398532,0 36.3524437,2.71259057 36.3524437,6.05874062 L36.3524437,18.4438295"
                            id="路径"
                            stroke="#FFFFFF"
                            strokeWidth="2.7"
                        ></path>
                        <line x1="0.229002195" y1="22.9468144" x2="21.24" y2="22.9468144" id="路径-7" stroke="#FFFFFF" strokeWidth="2.7"></line>
                        <line
                            x1="6.71021745"
                            y1="12.7035381"
                            x2="6.71021745"
                            y2="16.1068144"
                            id="路径-8"
                            stroke="#FFFFFF"
                            strokeWidth="2.7"
                            strokeLinecap="round"
                        ></line>
                        <line
                            x1="6.71021745"
                            y1="29.1752139"
                            x2="6.71021745"
                            y2="33.7120131"
                            id="路径-8备份"
                            stroke="#FFFFFF"
                            strokeWidth="2.7"
                            strokeLinecap="round"
                        ></line>
                        <rect id="矩形" stroke="#FFFFFF" strokeWidth="2.7" x="21.149387" y="17.4568144" width="36" height="41.4" rx="6.3"></rect>
                        <line x1="19.799387" y1="29.2120131" x2="57.1328654" y2="29.1752139" id="路径-9" stroke="#FFFFFF" strokeWidth="2.7"></line>
                        <circle id="椭圆形备份-5" fill="#FFFFFF" cx="26.410141" cy="25.1068144" r="1"></circle>
                        <circle id="椭圆形备份-6" fill="#FFFFFF" cx="30.3449547" cy="25.1068144" r="1"></circle>
                        <circle id="椭圆形" stroke="#FFFFFF" strokeWidth="2.7" cx="39.149387" cy="44.0620131" r="9"></circle>
                        <line
                            x1="52.3066069"
                            y1="24.2068144"
                            x2="45.6278948"
                            y2="24.2068144"
                            id="路径-10"
                            stroke="#FFFFFF"
                            strokeWidth="2.7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}
